<mat-form-field>
  <mat-label>{{ fieldLabel() }}</mat-label>

  <mat-chip-grid #chipGrid [attr.aria-label]="fieldLabel()" [disabled]="isDisabled()">
    @for (option of selectedOptions() ?? []; track optionIdentity(option)) {
      <mat-chip-row [removable]="!readOnly() && !isDisabled()" (removed)="removeOption(option)">
        {{ displayOption(option) }}
        @if (!readOnly() && !isDisabled()) {
          <button matChipRemove type="button" [attr.aria-label]="'Remover ' + displayOption(option)">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }

    <input #autocompleteInput matInput [id]="inputId()" [placeholder]="placeholder()"
      [formControl]="searchControl" [matAutocomplete]="autocomplete" [matChipInputFor]="chipGrid"
      [readOnly]="readOnly()" (input)="handleSearch(autocompleteInput.value)" (blur)="markAsTouched()" />
  </mat-chip-grid>

  <mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="selectOption($event)">
    @for (option of filteredOptions$ | async; track optionIdentity(option)) {
      <mat-option [value]="option">{{ displayOption(option) }}</mat-option>
    } @empty {
      <mat-option disabled>{{ emptyMessage() }}</mat-option>
    }
  </mat-autocomplete>

  @if (required() && touched && (selectedOptions() ?? []).length === 0) {
    <mat-error>{{ fieldLabel() || placeholder() }} é obrigatório</mat-error>
  }
</mat-form-field>
